module.exports = ".dialog-wrapper {\n  width: 70vw; }\n  .dialog-wrapper .textarea-input.mat-form-field {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/setting-dialog/setting-dialog.component.scss
// module id = 1533
// module chunks = 0